import React from 'react';
import { Badge } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const Chip = ({ children, variant = 'default', ...props }) => {
  const variantStyles = {
    default: {
      bg: '#f1ecff',
      color: '#7d23ff',
    },
    soft: {
      bg: 'purple.100',
      color: 'purple.700',
    },
    outline: {
      bg: 'transparent',
      border: '1px solid',
      borderColor: 'border.mid',
      color: 'text.main',
    },
  };

  return (
    <Badge
      className="zf-chip"
      borderRadius="999px"
      px={3}
      py={1}
      fontSize="13px"
      fontWeight={600}
      {...variantStyles[variant]}
      {...props}
    >
      {children}
    </Badge>
  );
};

Chip.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'soft', 'outline']),
};

export default Chip;
